import Model from './Model';

export default class WebhookIntegration extends Model {
  resource() {
    return 'webhook_integration';
  }
}
